import React from 'react';
import PropTypes from 'prop-types';
import Slick from 'react-slick';
import styled, { css } from 'styled-components';
import 'slick-carousel/slick/slick.css';

import { carouselCommon, crossScreenHeight, toVw, toVwMobile, toVwTablet, transitionDefault } from '../../utils/styles';
import Slide from './components/Slide';
import CarouselBehavior from '../CarouselBehavior';
import mq from '@/utils/media-queries';
import { TRANSITION_DURATION, TRANSITION_FUNCTION } from '../../constants';

export const SLIDER_HEIGHT = 864;

const Styled = styled.div`
  ${carouselCommon('#11F5FF')};
  ${crossScreenHeight(SLIDER_HEIGHT)};

  .slick-slider,
  .slick-list,
  .slick-track,
  .slick-slide {
    width: 100%;
    height: 100%;
  }

  ${mq.tablet(css`
    height: ${toVwTablet(576)};
  `)};

  ${mq.mobile(css`
    height: ${toVwMobile(360)};
  `)};
`;

const SlideWrapper = styled.div`
  ${props =>
    props.alternativeAnimation &&
    css`
      opacity: 0;
      transition: opacity ${TRANSITION_DURATION} ${TRANSITION_FUNCTION} !important;

      &.slick-active {
        opacity: 1;
      }
    `};
`;

class Carousel extends React.PureComponent {
  static propTypes = {
    className: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.object).isRequired,
    alternativeAnimation: PropTypes.bool,
    pager: PropTypes.object,
    showSlideBackground: PropTypes.bool,
  };

  state = {
    currentIndex: 0,
  };

  settings = {
    infinite: true,
    speed: 100,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    afterChange: index => this.setState({ currentIndex: index }),
    fade: true,
  };

  render() {
    const { className, items, alternativeAnimation, pager, showSlideBackground } = this.props;

    return (
      <CarouselBehavior onNext={() => this.slick.slickNext()} onPrev={() => this.slick.slickPrev()} infinite>
        <Styled className={className} pagerData={pager} innerRef={node => (this.containerNode = node)}>
          <Slick {...this.settings} ref={slick => (this.slick = slick)}>
            {items.map((item, index) => (
              <SlideWrapper key={index} alternativeAnimation={alternativeAnimation}>
                <Slide
                  {...item}
                  active={index === this.state.currentIndex}
                  alternativeAnimation={alternativeAnimation}
                  showBackground={showSlideBackground}
                />
              </SlideWrapper>
            ))}
          </Slick>
        </Styled>
      </CarouselBehavior>
    );
  }
}

export default Carousel;



// WEBPACK FOOTER //
// ./src/components/Carousel/index.js